<template>
  <div class="mobile-container">
    <div id="chartDashboard5Mobile">
      <cq-context>
        <cq-chart-instructions role="contentinfo"></cq-chart-instructions>
        <cq-color-picker></cq-color-picker>
        <div class="ciq-nav full-screen-hide" role="navigation">
          <!-- enables the more button when in break-sm mode -->
          <div class="sidenav-toggle ciq-toggles">
            <cq-toggle
              class="ciq-sidenav"
              member="sidenav"
              toggles="sidenavOn,sidenavOff"
              toggle-classes="active,"
              tooltip="More"
              icon="morenav"
              action="class"
            >
            </cq-toggle>
          </div>

          <cq-toggle
            class="ciq-lookup-icon"
            config="symbolsearch"
            reader="Symbol Search"
            tooltip="Symbol Search"
            icon="search"
            help-id="search_symbol_lookup"
          ></cq-toggle>
          <cq-toggle
            class="ciq-comparison-icon"
            config="symbolsearch"
            reader="Add Comparison"
            tooltip="Add Comparison"
            icon="compare"
            help-id="add_comparison"
            comparison="true"
          ></cq-toggle>

          <!-- any entry in this div will be shown in the side navigation bar in break-sm mode -->
          <cq-side-nav cq-on="sidenavOn">
            <div class="icon-toggles ciq-toggles">
              <cq-toggle
                class="ciq-draw"
                member="drawing"
                reader="Draw"
                tooltip="Draw"
                icon="draw"
                help-id="drawing_tools_toggle"
              ></cq-toggle>
              <cq-toggle
                class="ciq-CH"
                config="crosshair"
                reader="Crosshair"
                tooltip="Crosshair (Alt + \)"
                icon="crosshair"
              ></cq-toggle>
              <cq-menu
                class="nav-dropdown toggle-options"
                reader="Crosshair Options"
                config="crosshair"
              ></cq-menu>
              <cq-toggle
                class="ciq-HU"
                feature="tooltip"
                config="info"
                reader="Info"
                tooltip="Info"
                icon="info"
              ></cq-toggle>
              <cq-menu
                feature="tooltip"
                class="nav-dropdown toggle-options"
                reader="Info Options"
                config="info"
              ></cq-menu>
              <cq-toggle
                class="ciq-DT"
                feature="tableview"
                member="tableView"
                reader="Table View"
                tooltip="Table View"
                icon="tableview"
              ></cq-toggle>
            </div>
          </cq-side-nav>

          <div class="ciq-menu-section">
            <div class="ciq-dropdowns">
              <cq-menu
                class="nav-dropdown ciq-display"
                reader="Display"
                config="display"
                binding="Layout.chartType"
                icon=""
                help-id="display_dropdown"
                tooltip=""
              ></cq-menu>
              <cq-menu
                class="nav-dropdown ciq-period"
                reader="Periodicity"
                config="period"
                text=""
                binding="Layout.periodicity"
              ></cq-menu>
              <cq-menu
                class="nav-dropdown ciq-views alignright-md alignright-sm"
                config="views"
                text="Views"
                icon="views"
                responsive=""
                tooltip="Views"
              ></cq-menu>
              <cq-menu
                class="nav-dropdown ciq-studies alignright"
                cq-focus="input"
                config="studies"
                text="Studies"
                icon="studies"
                responsive=""
                tooltip="Studies"
              ></cq-menu>
              <cq-menu
                class="nav-dropdown ciq-markers alignright"
                config="markers"
                text="Events"
                icon="events"
                responsive=""
                tooltip="Events"
              >
                <span>Events</span>
                <cq-menu-dropdown>
                  <div class="markers-ui" style="display: inherit">
                    <cq-heading>Chart Events</cq-heading>
                    <cq-item stxtap="Markers.showMarkers('square')" cq-no-close=""
                      >Key Developments<span class="ciq-switch"
                        ><span></span
                      ></span>
                    </cq-item>
                  </div>
                </cq-menu-dropdown>
              </cq-menu>
              <cq-menu
                class="nav-dropdown ciq-preferences alignright"
                reader="Preferences"
                config="preferences"
                icon="preferences"
                tooltip="Preferences"
              ></cq-menu>
            </div>
            <div class="ciq-toggles"></div>
          </div>
        </div>
        <!-- End Navbar -->
        <div class="ciq-chart-area" role="main">
          <div class="ciq-chart">
            <cq-message-toaster
              defaultdisplaytime="10"
              defaulttransition="slide"
              defaultposition="top"
            ></cq-message-toaster>
            <cq-palette-dock>
              <div class="palette-dock-container">
                <cq-drawing-palette
                  class="palette-drawing grid palette-hide"
                  docked="true"
                  orientation="vertical"
                  min-height="300"
                  cq-drawing-edit="none"
                ></cq-drawing-palette>
                <cq-drawing-settings
                  class="palette-settings"
                  docked="true"
                  hide="true"
                  orientation="horizontal"
                  min-height="40"
                  cq-drawing-edit="none"
                ></cq-drawing-settings>
              </div>
            </cq-palette-dock>
            <div class="chartContainer">
              <!-- tooltip markup is required only if addon tooltip is used and customization is required -->
              <table class="hu-tooltip">
                <caption>
                  Tooltip
                </caption>
                <tbody>
                  <tr hu-tooltip-field="" class="hu-tooltip-sr-only">
                    <th>Field</th>
                    <th>Value</th>
                  </tr>
                  <tr hu-tooltip-field="DT">
                    <td class="hu-tooltip-name">Date/Time</td>
                    <td class="hu-tooltip-value"></td>
                  </tr>
                  <tr hu-tooltip-field="Close">
                    <td class="hu-tooltip-name"></td>
                    <td class="hu-tooltip-value"></td>
                  </tr>
                </tbody>
              </table>
              <cq-chart-title
                cq-marker=""
                cq-activate-symbol-search-on-click=""
              ></cq-chart-title>
              <cq-chartcontrol-group
                class="full-screen-show"
                cq-marker=""
              ></cq-chartcontrol-group>
              <cq-chart-legend></cq-chart-legend>
              <cq-loader></cq-loader>
            </div>
            <!-- End Chart Container -->
          </div>
          <!-- End Chart Box -->
        </div>
      </cq-context>
    </div>
  </div>
</template>

<script>
import { markers, quoteFeed, symbolLookupBase } from 'chartiq/js/standard';
import 'chartiq/js/advanced';
import 'chartiq/js/addOns';
import { CIQ } from 'chartiq/js/components';
import getDefaultConfig from 'chartiq/js/defaultConfiguration.js';
import api from '@/api/dashboard5';
let moment = require('moment');
import getLicenseKey from '@/keys/chartiq';
getLicenseKey(CIQ);

export default {
  name: 'Dashboard5Mobile',
  data: () => {
    return {
      query: 'AAPL:NASDAQGS',
      endDate: new Date(),
    };
  },
  methods: {
    refresh: async function () {
      // Remove existing lookup dialogs
      const divs = document.querySelectorAll('.cq-dialogs');
      for (const div of divs) {
        div.remove();
      }

      CIQ.activateImports(markers, quoteFeed, symbolLookupBase);
      CIQ.ChartEngine.Driver.Lookup.ChartIQ = function (exchanges) {
        this.exchanges = exchanges;
      };
      CIQ.inheritsFrom(
        CIQ.ChartEngine.Driver.Lookup.ChartIQ,
        CIQ.ChartEngine.Driver.Lookup
      );
      CIQ.ChartEngine.Driver.Lookup.ChartIQ.prototype.acceptText =
        async function (text, filter, maxResults, cb) {
          if (!text || text.length < 1) {
            return;
          }
          const response = await api.fetchChartIQSymbols(text);
          cb(response);
        };

      let labels = await api.fetchChartLabels(this.query);
      if (labels.errMsg != '') {
        alert(this.query + ' is not valid identifier : ' + labels.errMsg);
        return;
      }

      let fetch = async (symbol, startDate, endDate, params, cb) => {
        let s = moment(startDate).format('MM/DD/YYYY');
        let e = moment(endDate).format('MM/DD/YYYY');
        try {
          let quotes = await api.fetchChartIQPrices(symbol, s, e);
          let vk = await api.fetchChartIQVolumesAndKeyDevs(symbol, s, e);
          let volumes = vk['volumes'];
          let keydevs = vk['keydevs'];

          quotes.forEach((e) => {
            const v = volumes.find((i) => i.DT == e.DT);
            const k = keydevs.filter((i) => i.Date == e.DT);
            e['Volume'] = v['Volume'] * 1000000;
            e['Keydevs'] = k;
          });
          cb({
            quotes: quotes,
            moreAvailable: quotes.length > 0,
          });
        } catch (e) {
          cb({ error: e });
        }
      };
      let quotefeed = {
        // eslint-disable-next-line
        fetchInitialData: async function (
          symbol,
          startDate,
          endDate,
          params,
          cb
        ) {
          console.log('Asking for initial data...');
          fetch(symbol, startDate, endDate, params, cb);
        },
        // eslint-disable-next-line
        fetchUpdateData: async function (symbol, startDate, params, cb) {
          console.log('Asking for update data...');
        },
        // eslint-disable-next-line
        fetchPaginationData: async function (
          symbol,
          startDate,
          endDate,
          params,
          cb
        ) {
          console.log('Asking for pagination data...');
          fetch(symbol, startDate, endDate, params, cb);
        },
      };

      var markerfeed = function (stx) {
        this.stx = stx;
        this.activeLabels = [];
      };
      markerfeed.prototype.createMarkers = function (label) {
        this.stx.masterData.forEach((e) => {
          if (!e.Keydevs) return;
          e.Keydevs.forEach((k) => {
            new CIQ.Marker({
              stx: this.stx,
              label: label,
              xPositioner: 'date',
              x: new Date(k.Date),
              node: new CIQ.Marker.Simple({
                type: label,
                headline: k.data.headline,
                category: 'news',
                story: k.data.story,
              }),
            });
          });
        });
        return label;
      };
      markerfeed.prototype.processLabelsAndDraw = function (labels) {
        this.activeLabels = this.activeLabels.concat(labels);
        this.stx.draw();
        return labels;
      };
      markerfeed.prototype.hideMarkers = function (type) {
        let stx = this.stx;
        if (type) {
          CIQ.Marker.removeByLabel(stx, type);
          this.activeLabels = this.activeLabels.filter(
            (label) => label != type
          );
        } else {
          this.activeLabels.forEach(function (label) {
            CIQ.Marker.removeByLabel(stx, label);
          });
          this.activeLabels = [];
        }
      };
      markerfeed.prototype.showMarkers = function (type) {
        return this.processLabelsAndDraw(this.createMarkers(type));
      };

      const config = getDefaultConfig({
        markerFeed: markerfeed,
        quoteFeed: quotefeed,
      });
      config.chartId = 'chartDashboard5Mobile';
      const stxx = config.createChart(
        document.getElementById('chartDashboard5Mobile')
      );
      stxx.setRange({
        dtLeft: moment(new Date()).subtract(2, 'months').toDate(),
        dtRight: new Date(),
      });
      stxx.loadChart(
        {
          symbol: 'AAPL:NASDAQGS',
          name: 'Apple Inc',
          exchDisp: 'NasdaqGS',
        },
        { periodicity: { period: 1, interval: 'day' } }
      );
    },
  },
  mounted: async function () {
    // Remove padding from mobile-body for full-width chart
    const mobileBody = document.querySelector('.mobile-body');
    if (mobileBody) {
      mobileBody.style.padding = '0';
    }
    await this.refresh();
  },
  beforeUnmount: function () {
    // Restore padding when leaving Dashboard5
    const mobileBody = document.querySelector('.mobile-body');
    if (mobileBody) {
      mobileBody.style.padding = '';
    }
  },
};
</script>

<style>
@import '../../node_modules/chartiq/css/chartiq.css';
@import '../../node_modules/chartiq/css/stx-chart.css';
@import '../../node_modules/chartiq/css/webcomponents.css';
</style>

<style scoped>
.mobile-container {
  padding: 0;
  margin: 0;
  width: 100%;
  max-width: 100vw;
  height: calc(100vh - 60px);
  overflow-x: hidden;
  overflow-y: auto;
}

#chartDashboard5Mobile {
  width: 100%;
  max-width: 100%;
  height: 100%;
  overflow-x: hidden;
}

/* Mobile optimizations for ChartIQ */
:deep(.ciq-nav) {
  font-size: 12px;
  max-width: 100vw;
  overflow-x: auto;
}

:deep(.chartContainer) {
  height: calc(100vh - 120px);
  max-width: 100%;
  overflow-x: hidden;
}

/* Ensure ChartIQ is responsive */
:deep(.ciq-chart-area) {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
}

:deep(.ciq-chart) {
  max-width: 100%;
  overflow-x: hidden;
}

:deep(cq-context) {
  max-width: 100vw;
  overflow-x: hidden;
}

/* Hide complex menu items for mobile */
:deep(.ciq-views),
:deep(.ciq-studies),
:deep(.ciq-preferences),
:deep(.sidenav-toggle) {
  display: none !important;
}
</style>